import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store';

interface EventCounterState {
  count: number;
}

const initialState: EventCounterState = {
  count: 0,
};

export const eventCounterSlice = createSlice({
  name: 'eventCounter',
  initialState,
  reducers: {
    incrementEventCount: (state) => {
      state.count += 1;
    },
    resetEventCount: (state) => {
      state.count = 0;
    },
    setEventCount: (state, action: PayloadAction<number>) => {
      state.count = action.payload;
    },
  },
});

export const { incrementEventCount, resetEventCount, setEventCount } = eventCounterSlice.actions;

// Selector to get the event count
export const selectEventCount = (state: RootState) => state.eventCounter.count;

export default eventCounterSlice.reducer;
